import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
     meta: {
      title: 'Harry Beckwith Gardens - Home'
    },
    component: HomeView,
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: 'Harry Beckwith Gardens - Contact'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
  },
   {
    path: '/plant-list',
    name: 'plant-list',
    meta: {
      title: 'Harry Beckwith Gardens - Plant List'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/PlantListView.vue'),
  },
   {
    path: '/planting-plan',
    name: 'planting-plan',
    meta: {
      title: 'Harry Beckwith Gardens - Planting plan'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/PlantingPlanView.vue'),
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // Use the title from the route meta if it exists
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else {
    // Fallback title if no meta title is found
    document.title = 'My Default App Title'; 
  }

  next();
});

export default router
